<div
  class="absolute top-[120px] left-[92px] h-[38px] w-[119px] flex items-center bg-gris-4 border border-gris-3 rounded-[35px]"
>
  <button
    type="button"
    (click)="decrement.emit()"
    [disabled]="quantity() <= 0 || readOnly()"
    class="size-[38px] rounded-full bg-white border border-gris-3 flex items-center justify-center fg-gris-1 text-[24px] leading-none shrink-0 transition-colors"
    [class.cursor-pointer]="quantity() > 0 && !readOnly()"
    [class.hover:bg-gris-4]="quantity() > 0 && !readOnly()"
    [class.cursor-not-allowed]="quantity() <= 0 || readOnly()"
    [class.opacity-40]="quantity() <= 0 || readOnly()"
  >
    -
  </button>
  <span class="flex-1 text-center text-[14px] fg-gris-1 font-semibold">
    {{ quantity() }}
  </span>
  <button
    type="button"
    (click)="increment.emit()"
    [disabled]="disabled()"
    class="size-[38px] rounded-full flex items-center justify-center text-white text-[24px] leading-none shrink-0 transition-all"
    [class.bg-vert-1]="!disabled()"
    [class.cursor-pointer]="!disabled()"
    [class.bg-gris-3]="disabled()"
    [class.cursor-not-allowed]="disabled()"
  >
    +
  </button>
</div>
